export const programPivotColDefs = [
    {
        headerName: '연도',
        field: 'year',
        rowGroup: true,
    },
    {
        headerName: '지역',
        field: 'region',
    },
    {
        headerName: '교육신청자수',
        field: 'edu_applicants',
    },
    {
        headerName: '교육수혜자수',
        field: 'edu_beneficiaries',
    },
    {
        headerName: '수혜율',
        field: 'benefit_ratio',
        cellRenderer: params => {
            return params.value ? `${params.value}%` : ''
        },
    },
    {
        headerName: '초등학교',
        field: 'elem_school',
    },
    {
        headerName: '중학교',
        field: 'mid_school',
    },
    {
        headerName: '고등학교',
        field: 'high_school',
    },
    {
        headerName: '특수학교',
        field: 'spec_school',
    },
    {
        headerName: '남성',
        field: 'male',
    },
    {
        headerName: '여성',
        field: 'female',
    },
    {
        headerName: '미래채움센터 有',
        field: 'future_center_yes',
    },
    {
        headerName: '미래채움센터 無',
        field: 'future_center_no',
    },
    {
        headerName: '일반학생',
        field: 'reg_students',
    },
    {
        headerName: '소외계층',
        field: 'underprivileged',
    },
    {
        headerName: '일반학교',
        field: 'reg_schools',
    },
    {
        headerName: '도서벽지학교',
        field: 'book_walls_schools',
    },
    {
        headerName: '특수학교 (장애학교, 대안학교 등)',
        field: 'special_disability_schools',
    },
    {
        headerName: '기관 (아동복지센터 등)',
        field: 'child_welfare_institutions',
    },
    { headerName: '1~2시간', field: 'hour_1to2' },
    {
        headerName: '3~8시간 미만',
        field: 'hour_3to8',
    },
    {
        headerName: '8~30시간 미만',
        field: 'hour_8to30',
    },
    {
        headerName: '30~50시간 미만',
        field: 'hour_30to50',
    },
    {
        headerName: '50시간 이상',
        field: 'more50_hours',
    },
    {
        headerName: '온라인',
        field: 'online',
    },
    {
        headerName: '오프라인',
        field: 'offline',
    },
    {
        headerName: '센터내교육',
        field: 'within_center',
    },
    {
        headerName: '찾아가는교육',
        field: 'outreach_edu',
    },
    {
        headerName: '기타',
        field: 'other',
    },
]

export const tutorsPivotColDefs = [
    {
        headerName: '연도',
        field: 'year',
    },
    {
        headerName: '지역',
        field: 'region',
    },
    {
        headerName: '목표',
        field: 'goal',
    },
    {
        headerName: '실적 (연말기준 채용인원)',
        field: 'hired_count',
    },
    {
        headerName: '목표 대비 달성율',
        field: 'hired_ratio',
    },
    {
        headerName: '이탈인원 포함 합계',
        field: 'total_with_fail',
    },
    {
        headerName: '신규강사',
        field: 'new_employee',
    },
    {
        headerName: '재고용강사',
        field: 'reemployee',
    },
    { headerName: '(우선순위 미적용) 청년(35세 미만)', field: 'youth' },
    { headerName: '(우선순위 미적용) 경력단절여성', field: 'career_stop_woman' },
    { headerName: '(우선순위 미적용) 경력단절여성(재고용강사 채용시 기준)', field: 'career_stop_woman_reemployee' },
    { headerName: '(우선순위 미적용) 퇴직전문가', field: 'retired_expert' },
    { headerName: '(우선순위 미적용) 기타', field: 'etc' },
    { headerName: '(우선순위 미적용) 중복인원', field: 'duplicate_person' },
    { headerName: '(우선순위 적용) 청년(35세 미만) <1순위>', field: 'youth' },
    {
        headerName: '(우선순위 적용) 경력단절여성(재고용강사 채용시 기준) <2순위>',
        field: 'career_stop_woman_reemployee',
    },
    { headerName: '(우선순위 적용) 퇴직전문가 <3순위>', field: 'retired_expert' },
    { headerName: '(우선순위 적용) 기타 <4순위>', field: 'etc' },
    { headerName: '(연령기준) 20~29세', field: 'age_20s' },
    { headerName: '(연령기준) 30~39세', field: 'age_30s' },
    { headerName: '(연령기준) 40~49세', field: 'age_40s' },
    { headerName: '(연령기준) 50대이상', field: 'age_over_50' },
    { headerName: '(성별) 남성', field: 'male' },
    { headerName: '(성별) 여성', field: 'female' },
    { headerName: '(창업) 사업자등록완료', field: 'own_bussiness' },
    { headerName: '(고용형태) 정규직', field: 'full_time_contract' },
    { headerName: '(고용형태) 계약직', field: 'contract_worker' },
    { headerName: '(근로시간) 주 40시간 이상', field: 'over_40_week' },
    { headerName: '(근로시간) 주 15 ~ 39시간', field: 'work_15to39_week' },
    { headerName: '(근로시간) 주 15시간 미만', field: 'under_15_week' },
    { headerName: '(4대보험) 전부가입', field: 'full_insurance' },
    { headerName: '(4대보험) 일부가입', field: 'partial_insurance' },
    { headerName: '(4대보험) 미가입', field: 'no_insurance' },
    { headerName: '(계약기간) 정규직(무기계약직)', field: 'indefine_contract' },
    { headerName: '(계약기간) 21개월~30개월(2차 재고용)', field: 'secondary_recontract' },
    { headerName: '(계약기간) 11개월~20개월(1차 재고용)', field: 'first_recontract' },
    { headerName: '(계약기간) 10개월 이내(최초고용)', field: 'first_contract' },
    { headerName: '(ICTSW관련전공여부) 해당없음', field: 'ictswN' },
    { headerName: '(ICTSW관련전공여부) 해당', field: 'ictswY' },
    { headerName: '(전공구분) 인문과학', field: 'humanity_major' },
    { headerName: '(전공구분) 사회과학', field: 'social_science_major' },
    { headerName: '(전공구분) 자연과학', field: 'natural_science_major' },
    { headerName: '(전공구분) 공학', field: 'tech_major' },
    { headerName: '(전공구분) 예체능', field: 'art_major' },
    { headerName: '(전공구분) 기타', field: 'etc_major' },
    { headerName: '(SW강의경험) 없음', field: 'no_sw_experience' },
    { headerName: '(SW강의경험) 1년 미만', field: 'sw_experience_under_year' },
    { headerName: '(SW강의경험) 1년이상 3년미만', field: 'sw_experience_one_to_three' },
    { headerName: '(SW강의경험) 3년이상', field: 'sw_experience_over_three' },
    { headerName: '(기타강의경험) 없음', field: 'no_lec_experience' },
    { headerName: '(기타강의경험) 1년 미만', field: 'lec_experience_under_year' },
    { headerName: '(기타강의경험) 1년이상 3년미만', field: 'lec_experience_one_to_three' },
    { headerName: '(기타강의경험) 3년이상', field: 'lec_experience_over_three' },
    { headerName: '강사 평균 임금(월)', field: 'average_wage' },
]
// 공통 유틸
const ymdToDate = v => {
    if (!v) return null
    const [y, m, d] = String(v).split('T')[0].split('-').map(Number)
    return new Date(y, (m || 1) - 1, d || 1) // 로컬 자정
}

const makeDateComparator = mode => (filterLocalDateAtMidnight, cellValue) => {
    const cellDate = ymdToDate(cellValue)
    if (!cellDate) return mode === 'lte' ? 1 : -1
    if (cellDate < filterLocalDateAtMidnight) return -1
    if (cellDate > filterLocalDateAtMidnight) return 1
    return mode === 'gte' ? 1 : -1 // 같을 때: gte=통과, lte=통과
}

const vfDate = p => (p.value ? String(p.value).split('T')[0] : '')

const baseDateFilterParams = {
    suppressAndOrCondition: true,
    browserDatePicker: true,
    buttons: ['reset'],
}
export const programColDefs = [
    {
        // 활동연도와 같은 field 를 쓰는 필터·그룹 전용 컬럼.
        // colId 를 명시해 활동연도 컬럼과 구분한다(그리드 기본 필터가 이 colId 를 키로 사용).
        headerName: '연도',
        field: 'registrationYear',
        colId: 'registrationYearFilter',
        enableRowGroup: true,
        filter: 'agSetColumnFilter',
        filterParams: {
            suppressMiniFilter: false,
        },
    },
    { headerName: '지역', field: 'regionId', enableRowGroup: true },
    { headerName: '프로그램 아이디', field: 'programId', enableRowGroup: true },
    {
        headerName: '교육 기본 정보',
        children: [
            { headerName: '유형', field: 'educationType' },
            { headerName: '정규구분', field: 'course', enableValue: true, aggFunc: 'count' },
            { headerName: '카테고리1', field: 'category1', width: 220 },
            { headerName: '카테고리2', field: 'category2', width: 220 },
            { headerName: '카테고리3', field: 'category3', width: 220 },
            { headerName: '제목', field: 'programName', filter: 'agTextColumnFilter', width: 350, flex: 0 },
        ],
    },
    {
        headerName: '프로그램 운영정보',
        children: [
            { headerName: '교육시간 (교시)', field: 'classHours' },
            { headerName: '교육횟수 (회)', field: 'numberOfSession' },
            { headerName: '수강인원(명)', field: 'numberOfApplicants', enableValue: true, aggFunc: 'sum' },
            { headerName: '수료인원 (명)', field: 'numberOfGraduates', enableValue: true, aggFunc: 'sum' },
            { headerName: '운영상태', field: 'status', enableValue: true, aggFunc: 'sum' },
            { headerName: '아카이브', field: 'isCompleted', cellDataType: 'boolean' },
            // 컬럼
            {
                headerName: '교육 시작일',
                field: 'startDate',
                filter: 'agDateColumnFilter',
                width: 200,
                flex: 0,
                filterParams: {
                    ...baseDateFilterParams,
                    filterOptions: ['greaterThan'],
                    defaultOption: 'greaterThan',
                    comparator: makeDateComparator('gte'),
                },
                valueFormatter: vfDate,
            },
            {
                headerName: '교육 종료일',
                field: 'endDate',
                filter: 'agDateColumnFilter',
                width: 200,
                flex: 0,
                filterParams: {
                    ...baseDateFilterParams,
                    filterOptions: ['lessThan'],
                    defaultOption: 'lessThan',
                    comparator: makeDateComparator('lte'),
                },
                valueFormatter: vfDate,
            },
            { headerName: '활동연도', field: 'registrationYear' },
            {
                headerName: '주강사',
                field: 'mainTutorName',
                cellRenderer: params => {
                    if (!params.data.mainTutorName) return ''
                    const mainTutorName = params.data.mainTutorName.replaceAll(',', ', ')
                    return mainTutorName
                },
            },
            {
                headerName: '보조강사',
                field: 'subTutorName',
                cellRenderer: params => {
                    if (!params.data.subTutorName) return ''
                    const subTutorName = params.data.subTutorName.replaceAll(',', ', ')
                    return subTutorName
                },
            },
        ],
    },
    {
        headerName: '수요기관',
        children: [
            { headerName: '소외여부', field: 'isUnderserved', cellDataType: 'boolean' },
            { headerName: '구분', field: 'organizationType' },
            { headerName: '학년', field: 'grade' },
            { headerName: '학년/반', field: 'classroom' },
            { headerName: '기관명', field: 'organizationName' },
            { headerName: '주소', field: 'address' },
        ],
    },

    {
        headerName: '수요처 담당자',
        children: [
            { headerName: '성명', field: 'managerName' },
            { headerName: '직위/직책', field: 'managerPosition' },
            { headerName: '대표번호', field: 'managerTelNumber' },
            { headerName: '휴대전화', field: 'managerPhoneNumber' },
            { headerName: '이메일', field: 'managerEmail' },
            { headerName: '수요처 특이사항', field: 'managerRemark' },
        ],
    },
]

export const tutorsColDefs = [
    {
        headerName: '연도',
        field: 'registrationYear',
        enableRowGroup: true,
        filter: 'agSetColumnFilter',
        filterParams: {
            suppressMiniFilter: false,
        },
    },
    { headerName: '지역', field: 'regionId' },
    { headerName: '강사 아이디', field: 'tutorId' },
    {
        headerName: '구분',
        children: [
            {
                headerName: '고용 여부',
                field: 'isEmployment',
                cellRenderer: params => (params.value ? '재고용' : '신규'),
            },
            { headerName: '청년', field: 'isYouth', cellDataType: 'boolean' },
            { headerName: '전문퇴직자', field: 'isRetiree', cellDataType: 'boolean' },
            { headerName: '경력단절여성', field: 'isCareerGapFemale', cellDataType: 'boolean' },
            { headerName: '외국인', field: 'isForeign', cellDataType: 'boolean' },
            { headerName: '장애여부', field: 'isDisability', cellDataType: 'boolean' },
            { headerName: '보훈여부', field: 'isVeterans', cellDataType: 'boolean' },
            { headerName: '강사등급', field: 'advancedInstructor' },
        ],
    },
    {
        headerName: '강사 기본 정보',
        children: [
            { headerName: '성명', field: 'tutorName' },
            { headerName: '성별', field: 'gender' },
            {
                headerName: '생년월일',
                field: 'residentNum',
                cellClass: 'text-cell',
                valueFormatter: params => {
                    if (!params.value) return ''
                    // 하이픈 및 공백 제거
                    let value = String(params.value).replace(/[-\s]/g, '')
                    // 숫자가 아닌 문자 제거
                    value = value.replace(/\D/g, '')
                    // 6자리면 그대로 반환
                    if (value.length === 6) return value
                    // 6자리 이상이면 앞 자리만 노출
                    if (value.length > 6) return value.substring(0, 6)
                    // 그 외의 경우 원본 반환
                    return value
                },
            },
            { headerName: '주소', field: 'address' },
            { headerName: '연락처', field: 'contact' },
            { headerName: '이메일', field: 'email' },
            { headerName: '기수 (시작년도)', field: 'cohortStartYear' },
            { headerName: '권역', field: 'areaName' },
        ],
    },
    {
        headerName: '활동 정보',
        children: [
            {
                headerName: '계약시작',
                field: 'startDate',
                filter: 'agDateColumnFilter',
                width: 200,
                flex: 0,
                filterParams: {
                    ...baseDateFilterParams,
                    filterOptions: ['greaterThan'],
                    defaultOption: 'greaterThan',
                    comparator: makeDateComparator('gte'),
                },
                valueFormatter: vfDate,
            },
            {
                headerName: '계약만료',
                field: 'endDate',
                filter: 'agDateColumnFilter',
                width: 200,
                flex: 0,
                filterParams: {
                    ...baseDateFilterParams,
                    filterOptions: ['lessThan'],
                    defaultOption: 'lessThan',
                    comparator: makeDateComparator('lte'),
                },
                valueFormatter: vfDate,
            },
            {
                headerName: '활동형태',
                field: 'employmentType',
                valueFormatter: params => {
                    if (params.value === '협동조합') {
                        return '위촉'
                    }
                    return params.value || ''
                },
            },
            { headerName: '활동연도', field: 'registrationYear' },
        ],
    },
    {
        headerName: '학력 및 전공',
        children: [
            { headerName: '전공 (학과명)', field: 'major' },
            { headerName: '최종학력', field: 'educationLevel' },
        ],
    },
    {
        headerName: '자격증 정보',
        children: [
            { headerName: '교원자격보유', field: 'isTeacherCertification', cellDataType: 'boolean' },
            { headerName: '강의경험 유무', field: 'isTeachingExperience', cellDataType: 'boolean' },
            { headerName: '자격증', field: 'swCertification' },
            { headerName: '소프트웨어(SW·AI) 교육강사 자격증', field: 'privateCertification' },
            { headerName: '외국어 가능 여부', field: 'isLanguage', cellDataType: 'boolean' },
            { headerName: '사용 가능한 외국어', field: 'languages' },
        ],
    },
    {
        headerName: '기타',
        children: [
            { headerName: '자차여부', field: 'isCar', cellDataType: 'boolean' },
            { headerName: '협동조합', field: 'cooperative' },
            { headerName: '비고', field: 'remarks' },
        ],
    },
]

export const inventoryColDefs = [
    { headerName: '지역', field: 'regionId', enableRowGroup: true },
    { headerName: '자산 아이디', field: 'toolsId', enableRowGroup: true },
    {
        headerName: '교구재(자산) 정보',
        children: [
            { headerName: '교구재 명', field: 'toolsName' },
            { headerName: '제조사', field: 'manufacturer' },
            { headerName: '모델명', field: 'modelName' },
            { headerName: '취득연월', field: 'acquireDate' },
            { headerName: '단가', field: 'purchasePrice' },
            { headerName: '품목분류', field: 'toolsType' },
            { headerName: '자산번호', field: 'toolsNum' },
        ],
    },
    {
        headerName: '교구재 현황',
        children: [
            { headerName: '교구재 상태', field: 'toolsState' },
            { headerName: '불량 사유', field: 'defectReason' },
            { headerName: '수리내역 결과', field: 'repairResult' },
            { headerName: '폐기연월', field: 'disposeDate' },
        ],
    },
    {
        headerName: '기타',
        children: [
            { headerName: '센터명', field: 'centerName' },
            { headerName: '과목(활용)', field: 'subject' },
            { headerName: '비고', field: 'etc' },
        ],
    },
]

export const rentalColDefs = [
    { headerName: '지역', field: 'regionId', enableRowGroup: true },
    { headerName: '대여 아이디', field: 'rentalId', enableRowGroup: true },
    {
        headerName: '교구정보',
        children: [
            { headerName: '품목 (교구명)', field: 'toolsName' },
            { headerName: '자산번호 (제품번호)', field: 'toolsNum' },
        ],
    },
    {
        headerName: '대여자 정보',
        children: [{ headerName: '성명 (대여자)', field: 'tutorName' }],
    },
    {
        headerName: '대여 및 사용정보',
        children: [
            { headerName: '사용기관', field: 'usingInstitution' },
            { headerName: '대여상태', field: 'rentalState' },
            { headerName: '대여 신청일자', field: 'applicationDate' },
            { headerName: '대여 일자', field: 'dispatchDate' },
            { headerName: '반납 일자', field: 'returnDate' },
            { headerName: '대여/사용목적', field: 'purpose' },
        ],
    },
    {
        headerName: '기타',
        children: [
            { headerName: '센터명', field: 'centerName' },
            { headerName: '과목(활용)', field: 'subject' },
            { headerName: '비고', field: 'etc' },
        ],
    },
]
